import {
  params, shape, string as stringType, number as numberType, bool, arrayOf
} from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';

const { arrayOf: arrayOfPropType, number, shape: shapePropType, string } = proptypes;

export const projectsDataModel = {
  projects: params({
    accountId: stringType().isRequired()
  }).shape({
    totalProjects: numberType(),
    projects: arrayOf(
      shape({
        id: stringType(),
        projectId: stringType(),
        projectName: stringType(),
        status: stringType(),
        modifyDateTime: stringType(),
        createdBy: stringType(),
        createdByName: stringType(),
        isCreatedByTHDAssociate: bool(),
        numberOfItems: numberType().skip('skipNumberOfItems', true),
        images: arrayOf(stringType()).skip('skipImages', true),
        hasTradeCreditAttached: bool()
      })
    )
  })
};

export const projectPropType = shapePropType({
  id: string,
  projectName: string,
  projectId: string,
  numberOfItems: number,
  status: string,
  images: arrayOfPropType(string)
});
